<template>
    <div class="app-header-hamburger" :class="hamburgerClasses">
        <button
            type="button"
            class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white"
            @click="toggleMenu()"
        >
            <span class="sr-only">Open main menu</span>
            <svg
                class="h-8 w-8"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
            >
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
            </svg>
        </button>
    </div>
</template>

<script>
import {mapActions} from 'pinia';

export default {
    name: 'AppHeaderHamburger',
    computed: {
        hamburgerClasses() {
            const cls = {};
            cls['flex'] = true;
            return cls;
        },
    },
    methods: {
        ...mapActions(useHeaderStore, {
            toggleMenu: 'toggleMenu',
        }),
    },
};
</script>
